import React from "react";
import './Body15.css';
import {Link} from "react-router-dom"
import picture271 from './source/picture271.png'
import picture272 from './source/picture272.png'
import picture273 from './source/picture273.png'
import picture274 from './source/picture274.png'





function Body15() {

  return (
    <div className="body15">
      <div className="body15-box1">
        <div className="body15-box2">
          <div className="body15-box3">Zlechov</div>
          <div className="body15-box5"><div className="body15-box4"></div></div>
          <div className="body15-box6">
          <img className="body15-box6-picture" src={picture271} alt="picture1"/>
          <img className="body15-box6-picture" src={picture272} alt="picture1"/>
          <img className="body15-box6-picture" src={picture273} alt="picture1"/>
          <img className="body15-box6-picture" src={picture274} alt="picture1"/>
          </div>
          <div className="body15-box8"><div className="body15-box7"><Link to="/PageProjekty">Zpět</Link></div></div>
        </div> 
      </div> 
    </div>
  );
}

export default Body15;
